module.exports = __webpack_public_path__ + "static/main3_sp-8f47b0af2e11d021a67098dc7236013d.jpg";